var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_615_5226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_615_5226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 28.7694C15.3167 28.7694 14.7299 28.536 14.239 28.0694C13.7481 27.6027 13.4842 27.028 13.4473 26.3454H18.5513C18.5145 27.028 18.2506 27.6027 17.7597 28.0694C17.2688 28.536 16.682 28.7694 15.9993 28.7694ZM10.9633 24.1384V22.4634H21.0353V24.1384H10.9633ZM11.0917 20.2787C9.72813 19.3862 8.64968 18.2645 7.85635 16.9134C7.06279 15.562 6.66602 14.0547 6.66602 12.3913C6.66602 9.82624 7.58024 7.62946 9.40868 5.80102C11.2371 3.97257 13.434 3.05835 15.9993 3.05835C18.5647 3.05835 20.7616 3.97257 22.59 5.80102C24.4185 7.62946 25.3327 9.82624 25.3327 12.3913C25.3327 14.0547 24.9382 15.562 24.1494 16.9134C23.3605 18.2645 22.2797 19.3862 20.907 20.2787H11.0917ZM11.6507 18.6034H20.3617C21.3948 17.8922 22.2023 16.9935 22.7843 15.907C23.3664 14.8203 23.6573 13.6485 23.6573 12.3913C23.6573 10.2718 22.9109 8.46557 21.418 6.97268C19.9251 5.47979 18.1189 4.73335 15.9993 4.73335C13.8798 4.73335 12.0736 5.47979 10.5807 6.97268C9.08779 8.46557 8.34135 10.2718 8.34135 12.3913C8.34135 13.6485 8.63235 14.8203 9.21435 15.907C9.79635 16.9935 10.6085 17.8922 11.6507 18.6034Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.5f4a9b1bbfbdb9eb46682c9eeb651e7a.svg";
export { ForwardRef as ReactComponent };